import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

filterStyles.container = {
    css: css`
        padding-bottom: 15px;
    `,
};
filterStyles.datesContainer = {
    gap: 10,
    css: css`
        width: 100%;
    `,
};
filterStyles.orderNumberGridItem = {
    width: [12, 12, 3, 3, 2],
    css: css`
        input {
            max-height: 40px !important;
        }
    `,
};
filterStyles.fromGridItem = {
    width: 6,
    css: css`
        > div {
            width: 100%;
            div[class^="FormInputWrapper"] {
                margin-top: 3px !important;
                input {
                    height: 36px !important;
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    /* flex-basis: 30%;
                    max-width: 30%; */
                `,
                null,
                null,
                null,
            ])}
    `,
};
filterStyles.toGridItem = {
    width: 6,
    css: css`
        > div {
            width: 100%;
            div[class^="FormInputWrapper"] {
                margin-top: 3px !important;
                input {
                    height: 36px !important;
                }
            }
            div[class^="react-calendar"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            left: auto;
                            right: 0;
                        `,
                        css`
                            left: auto;
                            right: 0;
                        `,
                    ])}
            }
            @media (min-width: 992px) and (max-width: 1100px) {
                div[class^="react-datetime-picker"] {
                    /* padding: 0px !important; */
                }
                span[class^="IconWrapper"] {
                    /* padding-left: 2px !important; */
                    /* width: 40px !important; */
                    svg {
                        height: 20px;
                        width: 20px;
                    }
                }
            }
        }
    `,
};
filterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        > button {
            margin-right: 10px;
            background: #ffffff !important;
            border: 1px solid #1a1a1a !important;
            border-radius: unset;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
            }
            &:hover {
                background: unset;
            }
        }
    `,
};
filterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        > button {
            margin-right: 10px;
            background: #ffffff !important;
            border: 1px solid #1a1a1a !important;
            border-radius: unset;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
            }
            &:hover {
                background: unset;
            }
        }
    `,
};
filterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 26px;
        `,
    },
};

filterStyles.shipToGridItem = {
    width: [12, 12, 6, 5, 4],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-right: 15px;
                    `,
                    css`
                        padding-right: 15px;
                    `,
                    css`
                        padding-right: 5px;
                    `,
                    css`
                        padding-right: 15px;
                    `,
                    css`
                        padding-right: 15px;
                    `,
                ],
                "min",
            )}
    `,
};
filterStyles.orderNumberGridItem = {
    width: [12, 12, 6, 3, 2],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-left: 15px;
                    `,
                    css`
                        padding-left: 15px;
                    `,
                    css`
                        padding-left: 5px;
                    `,
                    css`
                        padding-left: 15px;
                    `,
                    css`
                        padding-left: 15px;
                    `,
                ],
                "min",
            )}
    `,
};
filterStyles.datesGridItem = {
    width: [12, 6, 6, 6, 6],
         css:css`
            /* div[class^="react-datetime-picker"] {
                z-index: 9 !important;   
        } */
        div[class^="react-calendar"] {
                        width: 100% !important;
                    }
        div[class^="FormInputWrapper"] .react-datetime-picker__clear-button svg {
            margin-bottom: -4px;
        }
    `
};
filterStyles.orderTotalOperatorGridItem = {
    width: [6, 6, 6, 3, 2],
};
filterStyles.orderTotalAmountGridItem = {
    width: [6, 6, 6, 3, 2],
};

filterStyles.appliedFiltersContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        > div {
            border-radius: 0;
            padding: 7px 21px;
            background: ${getColor("primary")};
            align-items: center;
            &:hover {
                background: ${getColor("text.accent")};
            }
            > button {
                background: transparent;
                &:hover {
                    background: ${getColor("text.accent")};
                }
                > span > svg {
                    color: ${getColor("primary.contrast")};
                }
            }
        }
    `,
};
